import type { SVGProps } from 'react'
const SvgSyTechSolidRuntimeConfig = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path fillOpacity={0.2} d="M2 8h6V2H2z" />
		<path d="M7 4h13v2H7z" />
		<path fillOpacity={0.2} d="M15 13H3v-3h12zm-2 7H3v-4h10z" />
		<path d="M5 8h3V2H5z" />
		<path fillOpacity={0.2} d="M16 22h6v-6h-6z" />
		<path d="M19 22h3v-6h-3zM18 4h2v12h-2z" />
	</svg>
)
export default SvgSyTechSolidRuntimeConfig
